import { Currency } from '@/core/currency/interfaces';

const XOF: Currency = {
    name: 'West African CFA Franc BCEAO',
    demonym: 'West African CFA',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '952',
    symbol: '₣',
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'XOF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default XOF;
